import React from "react";
import Colours from "../utils/Colours";

export default class SafeImage extends React.Component {
	constructor(props) {
		super(props);
		this.handleError = this.handleError.bind(this);
		this.state = {
			errored: false,
		};
	}

	handleError(event) {
		this.setState({
			errored: true,
		});
	}

	render() {
		const optionalImgProps = {};
		if (this.props.width) {
			optionalImgProps.width = this.props.width;
		}
		if (this.props.height) {
			optionalImgProps.height = this.props.height;
		}

		let src = this.props.src;
		if (this.state.errored && this.props.alt === undefined) {
			src = "/static/images/empty_favicon.png";
		}
		if ((this.state.errored || !src) && this.props.alt !== undefined) {
			return (
				<div
					style={{
						color: this.props.useColour ? Colours.getDistinctColour(this.props.alt.toUpperCase().charCodeAt(0)) : "#000000",
					}}
					className={this.props.styleClassName}
					title={this.props.title}
					onClick={this.props.onClick}
				>
					{this.props.alt.toUpperCase()}
				</div>
			);
		}
		return (
			<img
				className={this.props.styleClassName}
				onError={this.handleError}
				src={src}
				title={this.props.title}
				onClick={this.props.onClick}
				alt={this.props.alt}
				{...optionalImgProps}
			/>
		);
	}
}
